import React from "react";
import { LabelPropsWithoutRef } from "react-html-props";
import styled from "styled-components";

const FieldLabel = (props: Props) => {
  const { children, visuallyHidden, ...otherProps } = props;

  const [labelContent, ...otherChildren] = React.Children.toArray(children);

  return (
    <Wrapper visuallyHidden={visuallyHidden}>
      <Label {...otherProps}>{labelContent}</Label>
      {otherChildren}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ visuallyHidden: boolean }>`
  display: flex;

  visibility: ${({ visuallyHidden }) => visuallyHidden && "hidden"};
  height: ${({ visuallyHidden }) => visuallyHidden && "0px"};
`;

const Label = styled.label`
  display: block;
  flex: 1;
  font-family: ${({ theme }) => theme.font};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 0.5rem;
`;

interface Props extends LabelPropsWithoutRef {
  visuallyHidden?: boolean;
}

export default FieldLabel;
